
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {AccountReportsProps} from "types/props-obj/AccountReportsProps";

const initialState: AccountReportsProps = {
    apiEndPoint: "accounts",
    purchases:{},
    expenses:{},
    sales:{},
    profiteLoss:null,
    vatReport:null,
    pageLimit: 5,
    pageNumber: 1,
    isOpen: false,
    list: [],
    item: null,
    error: null,
    alertPopup: false
};

const accountReports = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Item list
        getList(state, action) {
            state.list.push(action.payload);
            state.list = state.list.filter((liste) => liste.id !== 0);
            state.isLoading=false;
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {
            state.isOpen = action.payload.isOpen;
        },
        // get Item details
        setItem(state, action) {
            state.item = action.payload;
            state.isLoading=false;
        },

        // GET Items
        setItemsSuccess(state, action) {
            state.purchases=action.payload.purchase;
            state.expenses=action.payload.expense;
            state.sales=action.payload.invoice;
            state.list = action.payload.data;
            state.current_page=action.payload.current_page;
            state.last_page=action.payload.last_page;
            state.total=action.payload.total;
            state.isLoading=false;
        },

        // ADD Item
        addItemSuccess(state, action) {
            state.list = [...state.list,action.payload];
            state.isLoading=false;
        },

        // ADD Item
        setProfitLoss(state, action) {
            state.profiteLoss = action.payload;
            state.isLoading=false;
        },

        setVatReport(state, action) {
            state.vatReport = action.payload;
            state.isLoading=false;
        },

        // EDIT Item
        editItemSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id === action.payload.id);

            state.item=action.payload;
            state.list[foundIndex] = action.payload;
            state.isLoading=false;
        },

        deleteItemSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
        },



        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },

    }
});


export default accountReports.reducer;

function getApiEndPoint(){
    return store.getState().accountReports.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setLoading,setPageLimit,setApiEndPoint } = accountReports.actions;
export function getList(params:any={}) {
    return async () => {
        dispatch(accountReports.actions.setLoading(true));
        try {
            const response = await axios.get([getApiEndPoint(),  'summary'].join('/'),{params:params});
            dispatch(accountReports.actions.setItemsSuccess(response.data));
        } catch (error) {
            dispatch(accountReports.actions.hasError(error));
        }
    };
}

export function getItem(id: number | undefined) {
    return async () => {
        dispatch(accountReports.actions.setLoading(true));

        try {
            const response = await axios.get([getApiEndPoint(),  id].join('/'));
            dispatch(accountReports.actions.setItem(response.data));
        } catch (error) {
            dispatch(accountReports.actions.hasError(error));
            dispatch(accountReports.actions.setLoading(false));
        }
    };
}

export function addItem(ls:any) {
    return async () => {
        dispatch(accountReports.actions.setLoading(true));
        try {
            const response = await axios.post(getApiEndPoint(), ls,{headers:{'Content-Type': 'multipart/form-data'}});
            dispatch(accountReports.actions.addItemSuccess(response.data));
        } catch (error) {
            dispatch(accountReports.actions.hasError(error));
            dispatch(accountReports.actions.setLoading(false));
        }
    };
}

export function editItem(id: number | undefined,ls: any) {
    return async () => {
        dispatch(accountReports.actions.setLoading(true));
        try {
            const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
            dispatch(accountReports.actions.editItemSuccess(response.data));
        } catch (error) {
            dispatch(accountReports.actions.hasError(error));
            dispatch(accountReports.actions.setLoading(false));
        }
    };
}

export function deleteItem(id: number | undefined) {
    return async () => {
        try {
            await axios.delete([getApiEndPoint(),  id].join('/'));
            dispatch(accountReports.actions.deleteItemSuccess(id));
        } catch (error) {
            dispatch(accountReports.actions.hasError(error));
        }
    };
}


export function getProfiteLoss() {
    return async () => {
        dispatch(accountReports.actions.setLoading(true));

        try {
            const response = await axios.get([getApiEndPoint(),  'profit-loss'].join('/'));
            dispatch(accountReports.actions.setProfitLoss(response.data));
        } catch (error) {
            dispatch(accountReports.actions.hasError(error));
            dispatch(accountReports.actions.setLoading(false));
        }
    };
}

export function getVatReport() {
    return async () => {
        dispatch(accountReports.actions.setLoading(true));

        try {
            const response = await axios.get([getApiEndPoint(),  'vat'].join('/'));
            dispatch(accountReports.actions.setVatReport(response.data));
        } catch (error) {
            dispatch(accountReports.actions.hasError(error));
            dispatch(accountReports.actions.setLoading(false));
        }
    };
}